export const FETCH_TOKEN = 'FETCH_TOKEN';
export const FETCH_NEW_TOKEN = 'FETCH_NEW_TOKEN';
export const VERIFY_TOKEN = 'VERIFY_TOKEN';
export const LOGOUT = 'LOGOUT';
